/* Preference tags supplement Shopify's native newsletter form. No simulated signups. */
(() => {
  'use strict';
  if (window.madballLaunchInitialized) return;
  window.madballLaunchInitialized = true;
  let trigger = null;
  const find = (selector) => document.querySelector(selector);
  const syncTags = (form) => {
    const tags = form.querySelector('[data-mb-tags]');
    if (!tags) return;
    const values = ['newsletter', 'madball-waitlist-v1'];
    const design = form.querySelector('[data-mb-design]');
    const size = form.querySelector('[data-mb-size]');
    if (design && design.value) values.push('mb-design-' + design.value);
    if (size && size.value) values.push('mb-size-' + size.value);
    tags.value = values.join(',');
  };
  const closeProduct = () => {
    const dialog = find('#mb-product-dialog');
    if (dialog && dialog.open) dialog.close();
  };
  const setPreference = (key) => {
    const select = find('[data-mb-design]');
    if (select && Array.from(select.options).some((option) => option.value === key)) {
      select.value = key;
      syncTags(select.form);
    }
    trigger = null;
    closeProduct();
    const destination = find('#mb-waitlist');
    if (destination) destination.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    const email = find('[data-mb-email]');
    if (email) email.focus({ preventScroll: true });
  };
  document.addEventListener('click', (event) => {
    const menu = event.target.closest('[data-mb-menu-toggle]');
    if (menu) {
      const nav = document.getElementById(menu.getAttribute('aria-controls'));
      const expanded = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', String(!expanded));
      if (nav) nav.hidden = expanded;
      return;
    }
    if (event.target.closest('.mb-mobile-nav a')) {
      const button = find('[data-mb-menu-toggle]');
      const nav = find('.mb-mobile-nav');
      if (button) button.setAttribute('aria-expanded', 'false');
      if (nav) nav.hidden = true;
    }
    const choice = event.target.closest('[data-mb-prefer]');
    if (choice) { event.preventDefault(); setPreference(choice.dataset.mbPrefer); return; }
    const opener = event.target.closest('[data-mb-open]');
    if (opener) {
      const card = opener.closest('[data-mb-card]');
      const dialog = find('#mb-product-dialog');
      if (!card || !dialog) return;
      event.preventDefault();
      if (typeof dialog.showModal !== 'function') { setPreference(card.dataset.mbKey); return; }
      const image = card.querySelector('img');
      const targetImage = dialog.querySelector('[data-mb-dialog-image]');
      targetImage.src = image.currentSrc || image.src;
      targetImage.alt = image.alt;
      dialog.querySelector('[data-mb-dialog-title]').textContent = card.dataset.mbTitle;
      dialog.querySelector('[data-mb-dialog-price]').textContent = card.dataset.mbPrice;
      dialog.querySelector('[data-mb-dialog-description]').textContent = card.dataset.mbDescription;
      const details = card.querySelector('[data-mb-details]');
      dialog.querySelector('[data-mb-dialog-details]').innerHTML = details ? details.innerHTML : '';
      dialog.querySelector('[data-mb-dialog-cta]').dataset.mbPrefer = card.dataset.mbKey;
      trigger = opener;
      dialog.showModal();
      dialog.scrollTop = 0;
      document.body.classList.add('mb-modal-open');
      return;
    }
    if (event.target.closest('[data-mb-close]')) closeProduct();
    const dialog = find('#mb-product-dialog');
    if (dialog && event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeProduct();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.id !== 'mb-product-dialog') return;
    document.body.classList.remove('mb-modal-open');
    if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const nav = find('.mb-mobile-nav');
    const button = find('[data-mb-menu-toggle]');
    if (nav && !nav.hidden) { nav.hidden = true; button.setAttribute('aria-expanded', 'false'); button.focus(); }
  });
  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-mb-waitlist-form]');
    if (form) syncTags(form);
  });
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-mb-waitlist-form]')) return;
    syncTags(event.target);
    // Shopify performs the actual submission and supplies its success/error response.
  });
  const init = () => {
    document.querySelectorAll('[data-mb-waitlist-form]').forEach(syncTags);
    const response = find('[data-mb-form-response]');
    if (response) response.focus();
  };
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('mb-modal-open'));
})();
